// Web sessions are a fixed 12 hours (see the server's AuthController SESSION_EXPIRES_IN)
// and can't be renewed. Expiry is read from the token itself rather than waiting for the
// server to answer 401 — the live host currently turns a 401 into a generic 500, so the
// status code alone never reliably tells the portal that the session is over.
const TOKEN_KEY = 'cbrne_token';
const USER_KEY = 'cbrne_user';
const EXPIRED_FLAG = 'cbrne_session_expired';

export function isTokenExpired(token) {
  if (!token) return true;
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const { exp } = JSON.parse(atob(payload + '='.repeat((4 - (payload.length % 4)) % 4)));
    return typeof exp === 'number' && exp * 1000 <= Date.now();
  } catch {
    return false; // unreadable token: let the server decide
  }
}

export function isSessionExpired() {
  const token = localStorage.getItem(TOKEN_KEY);
  return !!token && isTokenExpired(token);
}

// Clears the session and sends the user to the login page, which then explains why.
// A full page load (not a router navigate) so every poll, timer and socket stops with it.
export function endSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  sessionStorage.setItem(EXPIRED_FLAG, '1');
  if (window.location.pathname !== '/login') window.location.href = '/login';
}

// Read once by the login page: true if the user was just signed out for expiry.
export function consumeExpiredFlag() {
  const expired = sessionStorage.getItem(EXPIRED_FLAG) === '1';
  sessionStorage.removeItem(EXPIRED_FLAG);
  return expired;
}
